import { Slider } from "../objects/slider";

function initWhyUseUs() {
    $('.js-perks-slider').each(function () {
        var sliderId = '#' + $(this).attr('id');
        new Slider(sliderId);
    });
}

initWhyUseUs();